.responseOptions {
  flex-grow: 5;
  flex-basis: 0;
}

.responseOption {
  width: 100%;

  & label {
    font-size: 1em !important;
  }

  @media (min-width: 48em) {
    width: 100%;
  }
}
